/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import {BoldText, SemiBoldText} from '../Text';
import Colors from 'constants/Colors';
import {Box} from '../Grid';
import {Breakpoints} from "../../constants/Breakpoints";

export const Section = styled.div`

  & + & {
    margin-top: 36px;

    &::before {
      content: '';
      position: relative;
      left: 0;
      display: block;
      width: 100%;
      height: 1px;
      background-color: ${Colors.GRAY[4]};
      transform: translateY(-24px);
      
      @media (min-width: ${Breakpoints.lg}) {
        position: absolute;
      }
    }
  }
`;

export const SectionTitle = styled(SemiBoldText)`
  font-size: 20px;
  color: ${Colors.GRAY[1]};
`;

export const GridColumnTitle = styled(BoldText)`
  font-size: 14px;
  color: ${Colors.GRAY[1]};
  padding-right: 60px;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    font-size: 16px;
  }
`;

export const SectionLegend = styled(BoldText)`
  font-size: 12px;
  color: ${Colors.GRAY[2]};
`;

export const SectionHeader = styled(Box)`
  margin: 0 0 16px;
`;

export const SectionDivider = styled.div`
  height: 1px;
  background-color: ${Colors.GRAY[4]};
`;


